/**
 * Удаляет указанный параметр из текущего URL.
 *
 * @param param - Название параметра, который нужно удалить.
 */
export function removeQueryParam(param: string): void {
    // Создаем объект URL из текущего адреса
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    // Проверяем наличие параметра
    if (params.has(param)) {
        // Удаляем параметр
        params.delete(param);

        // Формируем новый поисковый запрос
        const newSearch = params.toString();
        const newUrl = `${url.pathname}${newSearch ? `?${newSearch}` : ''}${url.hash}`;

        // Обновляем URL без перезагрузки страницы
        window.history.replaceState({}, '', newUrl);
    }
}
